import {Pipe, PipeTransform} from "@angular/core";
import {ExternalNumberStatus} from "../../model/externalNumberStatus";

@Pipe({name: 'numberStatus'})
export class NumberStatus implements PipeTransform {
    transform(value: any) {
        return ExternalNumberStatus[value];
    }
}
